import request from '@/utils/request'

export function updateBuildBoxCfg(data) {
  return request({
    url: 'api/v1/bling-box/updateCfg',
    method: 'post',
    data: data
  })
}

export function getBuildBoxCfg(data) {
  return request({
    url: 'api/v1/bling-box/getCfg',
    method: 'post',
    data: data
  })
}

export function getBuildBoxAllCfg() {
  return request({
    url: 'api/v1/bling-box/getAllCfg',
    method: 'get'
  })
}
export function delBuildBoxCfg(data) {
  return request({
    url: 'api/v1/bling-box/deleteCfg',
    method: 'delete',
    data: data
  })
}

export function importBuildBoxCfg(data) {
  return request({
    url: 'api/v1/bling-box/importCfg',
    method: 'post',
    data: data
  })
}

export function importBuildBoxVCfg(data) {
  return request({
    url: 'api/v1/bling-box/importVCfg',
    method: 'post',
    data: data
  })
}
export function exportBuildBoxVCfg(data) {
  return request({
    url: 'api/v1/bling-box/exportVCfg',
    method: 'post',
    data: data
  })
}
export function exportBuildBoxCfg() {
  return request({
    url: 'api/v1/bling-box/exportCfg',
    method: 'get'
  })
}
